import { Stack, Typography, Button } from '@vapor/material'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type FooterOptionProps = {
  disabled: boolean
  text: string
  placeholder: string
  caption: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>
}

export function FooterOption(props: FooterOptionProps) {
  return (
    <Button //
      style={{ paddingTop: 6, paddingBottom: 6, paddingLeft: 16, paddingRight: 16, textTransform: 'none', textAlign: 'left' }}
      disabled={props.disabled}
      onMouseDown={props.onMouseDown}
      onClick={props.onClick}
    >
      <Stack direction="row" width="100%" alignItems="center" spacing={1}>
        <FontAwesomeIcon icon={faPlusCircle} />
        <Stack direction="column" width="100%">
          <Typography variant="body1">
            <strong>{props.text}</strong>
          </Typography>
          {props.disabled && <Typography variant="caption">{props.caption}</Typography>}
          <Typography variant="caption">{props.placeholder}</Typography>
        </Stack>
      </Stack>
    </Button>
  )
}
